<template lang="pug">

    .ui.form

        <!--suppress JSUnusedLocalSymbols -->
        additional-costs-form-row(
            ref='rows'
            v-for="(_, index) in valueModels"
            v-bind:key="index"
            v-bind:show-label="index === 0"
            v-on:remove="remove(index)"
            v-model="valueModels[index]"
        )

        .ui.right.aligned
            a.ui.basic.right.labeled.icon.button(v-on:click="addRow()")
                i.icon.plus
                | Zeile hinzufügen

</template>

<script>
    import * as R from 'ramda'
    import AdditionalCostsFormRow from './AdditionalCostsFormRow'

    export default {

        components: { AdditionalCostsFormRow },

        data() {
            // Zusatkosten klonen und als Value-Models nutzen
            let valueModels = R.clone(this.additionalCostModels)

            // Wenn keine Value-Models vorhanden, leeres erstellen
            if (valueModels.length === 0) {
                valueModels = [ this.createEmptyValueModel() ]
            }

            return { valueModels }
        },

        methods: {

            addRow() {
                this.valueModels = R.append({ price: this.priceModel.id }, this.valueModels)
            },

            createEmptyValueModel() {
                return { price: this.priceModel.id }
            },

            persist() {
                return R.compose(

                    // Promises zusammenfassen
                    // > [ Promise, Promise ]
                    // < Promise
                    promises => Promise.all(promises),

                    // Models speichern
                    // > [ { amount: 32 }, { amount: 42 } ]
                    // < [ Promise, Promise ]
                    R.map(R.ifElse(
                        // Pruefen ob ID vorhanden
                        R.propSatisfies(R.isNil, 'id'),

                        // Wenn nein, Model erstellen
                        model => this.$store.dispatch('additionalCosts/create', { model }),

                        // Ansonsten Model aktualisieren
                        model => this.$store.dispatch('additionalCosts/update', { id: model.id, model })
                    )),

                    // Models ohne Kosten entfernen
                    // > [ { }, { amount: undefined }, { amount: 32 }, { amount: 42 } ]
                    // < [ { amount: 32 }, { amount: 32 } ]
                    R.reject(R.propSatisfies(R.isNil, 'amount')),

                )(this.valueModels)

            },

            remove(index) {
                // Model bei `index` entfernen
                this.valueModels = R.remove(index, 1, this.valueModels)
            },

            async validate() {
                const validations = R.compose(

                    // Promises zusammenfassen
                    // > [ Promise, Promise ]
                    // < Promise
                    promises => Promise.all(promises),

                    // Alle Zusatzkosten-Zeilen validieren
                    // > [ VueComponent, VueComponent ]
                    // < [ Promise, Promise ]
                    R.map(fieldComponent => fieldComponent.validate()),

                )(this.$refs.rows)

                // Pruefen ob alle Zeilen positiv validiert wurden
                return R.all(R.equals(true), await validations)
            }

        },

        props: {

            additionalCostModels: {
                type: Array,
                required: true
            },

            priceModel: {
                type: Object,
                required: true
            }

        },

        watch: {

            additionalCostModels(models) {
                this.valueModels = models
            },

            valueModels(models) {
                // Wenn keine Models mehr vorhanden sind, leeres Models erstellen
                if (models.length === 0) {
                    this.valueModels = [ this.createEmptyValueModel() ]
                }
            }

        }

    }

</script>
